import barba from '@barba/core'
import aos from './utils/aos'
import lazyImgs from './utils/lazyImgs'
import relatedPeopleSwiper from './components/related-people-swiper'

window.currentURL = window.location.href;

barba.hooks.beforeEnter(({ next }) => {
	aos(next.container)
	lazyImgs(next.container)
	relatedPeopleSwiper(barba)
})

barba.hooks.afterEnter(({ next }) => {
	// after enter hook stuff
	window.currentURL = next.url.path;
	window.dispatchEvent(new Event('page-change'))
})

barba.hooks.beforeLeave(({ next }) => {
	// bedfore leave hook stuff
	window.scrollTo(0,0)
})

// import all transitions in the barba transitions folder
const transitions = []
const t = require.context('./transitions/', false, /\.js$/)
t.keys().forEach(key => transitions.push(t(key).default))

// import all views in the barba views folder
const views = []
const v = require.context('./views/', false, /\.js$/)
v.keys().forEach(key => views.push(v(key).default))

// initialise Barba.js
barba.init({
	transitions,
	views,
	timeout: 5000,
	debug: true
})
